import { useCallback, useState } from "react";

export interface DialogControl<ID = undefined> {
  id: ID;
  isOpen: boolean;
  onClose: () => void;
  onOpen: () => void;
  onOpenChange: (open: boolean) => void;
  data?: any;
  setData?: any;

  open(): void;

  close(): void;
}

export function useDialog(): DialogControl;
export function useDialog(id: string): DialogControl<string>;
export function useDialog(id?: string): DialogControl<string | undefined> {
  const [isOpen, setIsOpen] = useState(false);
  const [data, setData] = useState(null);

  const open = useCallback(() => {
    setIsOpen(true);
  }, []);

  const close = useCallback(() => {
    setIsOpen(false);
  }, []);

  const onOpenChange = useCallback((nextOpen: boolean) => {
    setIsOpen(nextOpen);
  }, []);

  return {
    id,
    isOpen,
    onOpen: open,
    onClose: close,
    data,
    setData,
    onOpenChange,
    open,
    close,
  };
}
